import(/* webpackMode: "eager", webpackExports: ["AudioProvider"] */ "/vercel/path0/app/contexts/AudioContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeedbackWidget"] */ "/vercel/path0/app/feedback/FeedbackWidget.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/LayoutClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/tufte.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/toc.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/tufte-charts.css");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/vercel/path0/ui/PostHogProvider.tsx");
